import format from "date-fns/format";
import formatDistanceToNow from "date-fns/formatDistanceToNow";
import { validDateTimeString } from "./validators"
import config from "../config/config";

export const isNumeric = (num) => {
  let dt = typeof num;
  if (num !== null && num !== undefined && (dt === 'number' || dt === 'string')) {
    return !isNaN(parseFloat(num)) && isFinite(num);
  } else {
    return false;
  }
}

export const notEmptyString = (str, minLength = 0) => {
  if (typeof str === 'string') {
    if (!minLength) {
      minLength = 0;
    }
    return str.trim().length > minLength;
  }
  return false;
}

export const emptyString = (str) => !notEmptyString(str);

export const extractString = (obj, key) => {
  let str = '';
  if (obj instanceof Object) {
    if (notEmptyString(obj[key])) {
      str = obj[key];
    }
  }
  return str;
}

export const extractBool = (obj, key) => {
  let val = false;
  if (obj instanceof Object) {
    if (obj[key]) {
      switch (typeof obj[key]) {
        case 'boolean':
          val = obj[key];
          break;
        case 'number':
          val = obj[key] > 0;
          break;
        case 'string':
          if (isNumeric(obj[key])) {
            val = parseInt(obj[key]) > 0;
          } else {
            switch (obj[key].toLowerCase()) {
              case 'true':
              case 'yes':
                val = true;
                break;
            }
          }
          break;
      }
    }
  }
  return val;
}

export const dateToYear = (strDate) => {
  if (validDateTimeString(strDate)) {
    const date = new Date(strDate);
    return date.getFullYear();
  }
  return 0;
}

export const toDateTime = (strDate) => {
  if (validDateTimeString(strDate)) {
    return new Date(strDate);
  }
}

export const toMillitime = (strDate) => {
  let ts = 0;
  const dt = toDateTime(strDate);
  if (dt) {
    ts = dt.getTime();
  }
  return ts;
}

export const yearYoDateString = year => {
  if (isNumeric(year)) {
    year = parseInt(year);
    return [year, '07', '01'].join('-') + 'T00:00:00';
  }
}

export const formatDate = (datetime, fmt) => {
  if (datetime) {
    if (!fmt) {
      fmt = 'dd/MM/yyyy';
    }
    if (typeof datetime === "string" && validDateTimeString(datetime)) {
      datetime = toDateTime(datetime);
    }
    return format(datetime, fmt);
  }
}

export const toRelativeTime = (datetime) => {
  if (datetime) {
    if (typeof datetime === "string" && validDateTimeString(datetime)) {
      datetime = toDateTime(datetime);
    }
    return formatDistanceToNow(datetime, {
      includeSeconds: false
    });
  }
}

export const secondsToHMS = seconds => {
  let parts = [];
  if (isNumeric(seconds)) {
    if (seconds >= 3600) {
      parts.push((Math.floor(seconds / 3600)) + 'h')
    }
    if (seconds >= 60) {
      parts.push(((Math.floor(seconds / 60)) % 60) + 'm')
    }
    const secs = seconds % 60;
    if (secs) {
      parts.push(secs + 's')
    }
  }
  return parts.join(' ');
}

export const expandPath = (path) => {
  return config.mediaPath + path;
}

export const stripHtml = val => {
  let str = '';
  if (typeof val === 'string') {
    str = val.trim();
    if (/<\w+[^>]*?>/.test(str)) {
      str = str.replace(/<\/?\w+[^>]*?>/g, ' ').replace(/\s\s+/g, ' ');
    }
  }
  return str;
}

export const extractKeyValue = (obj, key, defVal) => {
  let output = defVal;
  if (obj instanceof Object) {
    const matchedVals = Object.entries(obj).filter(entry => entry[0] === key).map(pair => pair[1]);
    if (matchedVals.length > 0) {
      output = matchedVals.shift();
    }
  }
  return output;
}

export const extractSeqIntFromGuid = str => parseInt(str.substring(18), 16);

export const extractId = obj => {
  let id = "";
  if (obj instanceof Object) {
    if (obj._id) {
      id = obj._id;
    }
  }
  return id;
}

export const hasObjectId = obj => {
  return extractId(obj).length > 3;
}

export const extractSeq = obj => {
  let id = -1;
  const guid = extractId(obj);
  if (guid.length > 18) {
    id = extractSeqIntFromGuid(guid);
  }
  return id;
}

export const toKeyString = text => {
  let key = '';
  if (typeof text === 'string') {
    key = text.toLowerCase().replace(/-/g, '_').replace(/["',;)(.?]+/, '').replace(/[^a-z0-9]+/g, '_').replace(/__+/g, '_');
  }
  return key;
}

export const toWords = (val) => {
  let str = '';
  if (typeof val === 'string') {
    str = val.replace(/_+/g, ' ').replace(/([a-z0-9])([A-Z])/g, "$1 $2").toLowerCase();
  }
  return str;
}

export const extractNestedOptions = (group, key, options) => {
  let opts = [];
  if (options instanceof Array) {
    const optGroup = options.find(og => og.name === group);
    if (optGroup) {
      if (optGroup.fields instanceof Array) {
        const optSet = optGroup.fields.find(op => op.key === key);
        if (optSet) {
          if (optSet.options instanceof Array) {
            opts = optSet.options
          }
        }
      }
    }
  }
  return opts;
}

export const arrayDiff = (arr1, arr2) => arr1.filter(x => !arr2.includes(x));

export const fileHasChanged = (cv, pv) => {
  let valid = false;
  if (cv !== pv) {
    let hasChanged = true;
    if (pv instanceof Object) {
      hasChanged =
        cv.name !== pv.name || cv.lastModified !== pv.lastModified;
    }
    if (hasChanged) {
      valid = cv instanceof File;
    }
  }
  return valid;
}